export enum ManualReplenishOrderStatus {
  CREATED = 'CREATED',
  QUEUED = 'QUEUED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}
